import { Injectable } from '@angular/core';
import { InternalError } from 'common';
import { Observable, map, throwError } from 'rxjs';
import { OrderIncidence } from 'src/app/order/model/order-incidence';
import { OrderKey } from 'src/app/order/model/order-key';
import { OrderLineStatus } from 'src/app/order/model/order-line-status';
import { OrderState } from 'src/app/order/model/order-state';
import { OrderApiHelper } from 'src/app/order/services/order-api-helper';
import { OrderService } from 'src/app/order/services/order.service';
import { ArticleIncidentType } from '../model/article-incident-type';
import { OrderLineIncidentView } from '../model/order-line-incident-view';
import { IncidentApiService } from './incident-api.service';

@Injectable({
  providedIn: 'root'
})
export class IncidentService {

  private statusList = [OrderLineStatus.Incident, OrderLineStatus.Damage, OrderLineStatus.Missing];

  constructor(
    private incidentApiService: IncidentApiService,
    private orderService: OrderService,
  ) { }

  public filterIncident(lines: OrderLineIncidentView[]): OrderLineIncidentView[] {
    return lines !== undefined && lines !== null ?
      lines.filter(value => value.incidentType !== undefined) : [];
  }

  public filterIncidentByType(type: ArticleIncidentType, lines: OrderLineIncidentView[]): OrderLineIncidentView[] {
    return lines !== undefined && lines !== null ? lines.filter(value => value.incidentType === type) : [];
  }

  public filterDamage(lines: OrderLineIncidentView[]): OrderLineIncidentView[] {
    return this.filterIncidentByType(ArticleIncidentType.Damaged, lines);
  }

  public filterMissing(lines: OrderLineIncidentView[]): OrderLineIncidentView[] {
    return this.filterIncidentByType(ArticleIncidentType.Missing, lines);
  }

  public isTechnicalIncident(lines:  OrderIncidence[]): boolean {
    return lines !== undefined && lines !== null && lines.find(value => value.articleIncidentType === ArticleIncidentType.Technical) !== undefined;
  }

  public declareIncident(orderId: OrderKey,
    sku: string, count: number, status: ArticleIncidentType): Observable<OrderState> {
    const order = this.orderService.getOrder(orderId);
    if (order === undefined) {
      return throwError(() => new InternalError('DECLAREINCIDENT_2', 'No se puedo recuperar la orden para declarar el incidente', undefined, undefined));
    } else {
      return this.incidentApiService
        .declareIncident(order.pickId, order.id, sku, count, status)
        .pipe(
          map(data => {
            return data.Datos?.length === 0 ? OrderState.Unknow : OrderApiHelper.convertStatus(data.Datos?.[0]['Order Status'])
          })
        )
    }
  }

  public declareOrderIncident(orderId: OrderKey, incidence: OrderIncidence): Observable<OrderState> {
    const order = this.orderService.getOrder(orderId);
    if (order === undefined) {
      return throwError(() => new InternalError('DECLAREINCIDENT_2', 'No se puedo recuperar la orden para declarar el incidente', undefined, undefined));
    } else {
      return this.incidentApiService
        .declareOrderIncident(order.pickId, order.id, incidence.articleIncidentType)
        .pipe(
          map(data => {
            return data.Datos.length === 0 ? OrderState.Unknow : OrderApiHelper.convertStatus(data.Datos[0]['Order Status'])
          })
        )
    }
  }
}
